module.exports = __webpack_public_path__ + "img/space-bar.419cc98e.svg";